<template>
  <div class="login-box">
    <div class="notes-box">
      <img src="@/assets/logo.png" width="150px" />
      <div class="user-tips">
        <div class="user-tip" v-for="item in tips" :key="item.name">
          <img :src="item.icon" class="tip-icon" :alt="item.name" />
          <span>{{ item.text }}</span>
        </div>
      </div>
    </div>
    <div class="facebook-login-button">
      <a class="flex-center" @click="handleLogin">
        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"
          />
        </svg>
        <span class="login-tip">
          Sign in with Facebook
        </span>
      </a>
    </div>
    <div class="copyright">
      ©️ Copyright 2021 Lyramob
    </div>
  </div>
</template>

<script>
import { oauthLink } from "@/service/const";
import coinPng from "@/assets/images/coin.png";
import securityPng from "@/assets/images/security.png";
import readPng from "@/assets/images/read.png";
import { setToStorage } from "@/service/utils";

export default {
  data() {
    this.tips = [
      { name: "coin", text: "Log in to keep purchase history", icon: coinPng },
      { name: "security", text: "Keep your information more secure", icon: securityPng },
      { name: "read", text: "Enjoy better reading experience", icon: readPng }
    ];
    return {
      user: {}
    };
  },
  methods: {
    handleLogin() {
      window.location.href = oauthLink;
      window.$event("Login_Button_Click", {});
    }
  },
  mounted() {
    window.$event("Login_Page_Show", {});
  },
  beforeRouteEnter(to, from, next) {
    setToStorage("LOGIN_FROM", {
      name: from.name,
      query: from.query
    });
    next();
  }
};
</script>

<style lang="scss" scoped>
.login-box {
  .notes-box {
    background: linear-gradient(180deg, #f4efff, #ffffff);
    height: 60vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .user-tips {
      margin-top: 40px;
      .user-tip {
        display: flex;
        align-items: center;
        height: 35px;
        font-weight: 500;
        .tip-icon {
          width: 20px;
          margin-right: 10px;
        }
      }
    }
  }
  .copyright {
    width: 100%;
    position: fixed;
    bottom: 0;
    text-align: center;
    padding: 20px 10px;
    color: $fc-grey;
    font-size: $fs-xs;
  }
}
.facebook-login-button {
  display: flex;
  margin: 0 10vw;
  color: white;
  align-items: center;
  height: 50px;
  border-radius: 25px;
  box-sizing: border-box;
  justify-content: center;
  border: 1px solid rgba(white, 0.05);
  background-color: lighten($color-blue, 1%);
  .login-tip {
    margin-left: 10px;
  }
  a {
    text-decoration: none;
    color: white;
  }
}
</style>
